<script module>
    export { default as layout } from '../../layouts/AppLayout.svelte';
</script>

<script lang="ts">
    import CaseEditor from '../../components/CaseEditor.svelte';

    let { case: existingCase = null, existingMedia = null, computedStatus = null, revisionFeedback = null, topics = [] }: {
        case: any;
        existingMedia: any;
        computedStatus: string | null;
        revisionFeedback: string | null;
        topics: any[];
    } = $props();
</script>

<svelte:head>
    <title>{existingCase ? 'Edit Case' : 'New Case'} — Case of the Day</title>
</svelte:head>

<div class="max-w-3xl mx-auto">
        <h1 class="text-2xl font-bold text-gray-100 mb-6">
            {existingCase ? 'Edit Case' : 'Submit New Case'}
        </h1>

        {#if computedStatus === 'needs_revision'}
            <div class="rounded-lg border border-violet-500/30 bg-violet-950/40 px-5 py-4 text-violet-300 mb-6">
                <div class="flex items-center gap-3">
                    <svg class="size-5 shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor"><path opacity=".4" d="M0 160c0-53 43-96 96-96l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 160z"/><path d="M392.4 21.7L368 46.1 465.9 144 490.3 119.6c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0zM334.1 80L172.4 241.7c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L432 177.9 334.1 80z"/></svg>
                    <span class="text-sm font-medium">A reviewer has requested revisions to your case.</span>
                </div>
                {#if revisionFeedback}
                    <!-- eslint-disable-next-line svelte/no-at-html-tags -- server-sanitized markdown -->
                    <div class="mt-2 ml-8 text-sm text-violet-400/80 prose prose-invert prose-sm max-w-none">{@html revisionFeedback}</div>
                {/if}
            </div>
        {/if}
        <div class="bg-gray-900 rounded-lg shadow border border-gray-700 px-4 py-5 sm:p-6">
            <CaseEditor case={existingCase} {existingMedia} {computedStatus} {topics} />
        </div>
    </div>
